import { render, staticRenderFns } from "./AddProofing.vue?vue&type=template&id=99db94d4&"
import script from "./AddProofing.vue?vue&type=script&lang=js&"
export * from "./AddProofing.vue?vue&type=script&lang=js&"
import style0 from "./AddProofing.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports